import { defineMessages } from 'react-intl';

export default defineMessages({
    appName: {
        id: 'portal.account management.name',
        defaultMessage: 'CustomerEngage Account Management'
    },
    account: {
        id: 'portal.account management.index.Account',
        defaultMessage: 'Account'
    },
    faq: {
        id: 'portal.account management.index.FAQ',
        defaultMessage: 'FAQ'
    },
    home: {
        id: 'app.account management.html.index.Home',
        defaultMessage: 'Home'
    },
    logout: {
        id: 'portal.account management.index.Logout',
        defaultMessage: 'Logout'
    },
    additionalEnrollment: {
        id: 'portal.account management.index.Additional Enrollment',
        defaultMessage: 'Additional Enrollment'
    },
    makeAPayment: {
        id: 'portal.account management.index.Make a Payment',
        defaultMessage: 'Make a Payment'
    },
    billingSummary: {
        id: 'portal.account management.index.Billing',
        defaultMessage: 'Billing'
    },
    claimList: {
        id: 'portal.account management.index.Claims',
        defaultMessage: 'Claims'
    },
    claimDetails: {
        id: 'portal.account management.index.Claim Details',
        defaultMessage: 'Claim Details'
    },
    createNote: {
        id: 'portal.account management.index.Create Note',
        defaultMessage: 'Create Note'
    },
    policyChange: {
        id: 'portal.account management.index.Policy Change',
        defaultMessage: 'Policy Change'
    },
    policyDetails: {
        id: 'portal.account management.index.Policy Details',
        defaultMessage: 'Policy Details'
    },
    accountInformation: {
        id: 'portal.account management.index.Account Information',
        defaultMessage: 'Account Information'
    },
    homePage: {
        id: 'portal.account management.index.Home Page',
        defaultMessage: 'Home Page'
    },
    error: {
        id: 'portal.account management.index.Error',
        defaultMessage: 'Error'
    },
    errorMessage: {
        id: 'portal.account management.index.Sorry, an error occurred. You can try later or contact one of our agents.',
        defaultMessage: 'Sorry, an error occurred. You can try later or contact one of our agents.'
    },
    backButton: {
        id: 'portal.account management.index.Back',
        defaultMessage: 'Back'
    },
});
